/* Utilidades globales: bloqueo de scroll (verbatim del original, scripts-tail-a) */
(function(){
var lockCount = 0;
var lockScrollY = 0;
window.henuaLockScroll = function(){
if(lockCount === 0){
lockScrollY = window.scrollY;
document.body.style.position = 'fixed';
document.body.style.top = (-lockScrollY) + 'px';
document.body.style.left = '0';
document.body.style.right = '0';
document.body.style.width = '100%';
}
lockCount++;
};
window.henuaUnlockScroll = function(){
lockCount = Math.max(0, lockCount - 1);
if(lockCount === 0){
document.body.style.position = '';
document.body.style.top = '';
document.body.style.left = '';
document.body.style.right = '';
document.body.style.width = '';
window.scrollTo(0, lockScrollY);
}
};
})();

/* Enlaces heredados de la web estática (*.html) -> rutas nativas de Shopify.
   Cubre contenido pegado desde el sitio original (políticas, páginas, paneles). */
(function(){
var R = window.henuaRoutes || {};
var root = (R.root || '/').replace(/\/?$/, '/');
var map = {
'index.html': root,
'coleccion.html': root + 'collections/all',
'historia.html': root + 'pages/historia',
'sobre-henua.html': root + 'pages/sobre-henua',
'ayuda.html': root + 'pages/ayuda'
};
function convert(href){
if(!href) return null;
var m = href.match(/^(?:\.?\/)?(index|coleccion|historia|sobre-henua|ayuda|producto)\.html(\?[^#]*)?(#.*)?$/);
if(!m) return null;
var name = m[1], query = m[2] || '', hash = m[3] || '';
if(name === 'producto'){
var slug = (query.match(/[?&]slug=([^&]+)/) || [])[1];
return slug ? root + 'products/' + slug + hash : root + 'collections/all' + hash;
}
return map[name + '.html'] + hash;
}
window.henuaLegacyHref = convert;
function rewrite(scope){
(scope || document).querySelectorAll('a[href*=".html"]').forEach(function(a){
var n = convert(a.getAttribute('href'));
if(n) a.setAttribute('href', n);
});
}
document.addEventListener('click', function(e){
var a = e.target.closest ? e.target.closest('a[href*=".html"]') : null;
if(!a) return;
var n = convert(a.getAttribute('href'));
if(n){ a.setAttribute('href', n); }
}, true);
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ rewrite(); });
else rewrite();
})();

/* Accesibilidad: foco dentro de diálogos modales (WCAG 2.1.2 sin trampa, 2.4.3 orden de foco). */
(function(){
var SEL = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
function visible(el){
if(el.hidden || el.closest('[hidden]')) return false;
var cs = window.getComputedStyle(el);
return cs.visibility !== 'hidden' && cs.display !== 'none' && (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0);
}
window.henuaFocusables = function(container){
return Array.prototype.slice.call(container.querySelectorAll(SEL)).filter(visible);
};
/* Llamar desde un keydown: mantiene Tab / Shift+Tab dentro de `container`. */
window.henuaTrapTab = function(e, container){
if(e.key !== 'Tab' || !container) return;
var f = window.henuaFocusables(container);
if(!f.length){ e.preventDefault(); return; }
var first = f[0], last = f[f.length - 1];
if(!container.contains(document.activeElement)){ e.preventDefault(); first.focus(); return; }
if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
};
/* Los enlaces que abren un panel avisan que abren un diálogo (WCAG 4.1.2). */
function markPanelLinks(){
document.querySelectorAll('.hn-footer-link').forEach(function(a){
if(!a.hasAttribute('aria-haspopup')) a.setAttribute('aria-haspopup', 'dialog');
});
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markPanelLinks); else markPanelLinks();
})();
